// Interface, Modals, enum etc....

export const PATTERNs = {
    email: /^([A-Za-z0-9_\-+\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
    emailHard: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
    //password: /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
    password: /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*()\-_=+{};:,<.>])([^\s])+$/
}
export interface USER {
    email: string,
    id: string | number,
    reset_at: string,
    role: string,
    status: string
    temp_user: boolean,
    token: string,
    username: string,
    franchisee_name: string,
    franchisee_id: string | number
}

export const LANDING_ROUTE = {
    "guest": "/login",
    "Super Admin": "/dashboard",
    "Franchise Partner": "/franchise-summary",
    "Head Office Role": "/reports",
}

export const ROLES_LIST = {
    "Super Admin": "Super Admin",
    "Franchise Partner": "Franchise Admin",
    "Head Office Role": "HO Admin",
}
